const Footer = () => {
  return (
    <footer className="sticky-footer bg-white">
      <div className="container my-auto">
        <div className="copyright text-center my-auto">
          <span>Copyright © 2024 Cirayedaar All Rights Reserved</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
  